/* eslint-disable */
/* this file is generated by generateIcons script */

import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class AdminsIcon extends BaseIcon {
  getChildren = () => [
    <path fill={ this.getColor() }
          style={{fillRule: 'evenodd'}}
          d="M15.989,16.012H5.01L5.027,14.7a5.789,5.789,0,0,1,3.153-2.582A21.5,21.5,0,0,0,10.4,13.99a21.316,21.316,0,0,0,2.341-1.869A5.811,5.811,0,0,1,15.99,14.8v1.215ZM13.009,8.1c0,1.708-.917,2.888-2.531,2.888S8.006,9.811,8.006,8.1c0-.039,0-0.075,0-0.114h5C13.009,8.027,13.009,8.064,13.009,8.1ZM7.852,6.99L6.99,4l2.1,1.082L10.5,2.992,11.907,5.08,14.01,4,13.173,6.99H7.852ZM1.744,3.012L1,1,3,2,4,0.01,5,2,7,1,6.278,3.012H1.744ZM2.005,4.084c0-.026,0-0.05,0-0.075h4c0,0.026,0,.05,0,0.075A1.829,1.829,0,0,1,3.983,5.992,1.792,1.792,0,0,1,2.005,4.084ZM2.829,7.008C3.253,7.412,3.664,7.76,4,8.045c0.37-.295.8-0.635,1.228-1.024h0.1a3.74,3.74,0,0,1,.7.076C6.02,7.27,5.991,7.437,5.991,7.613a5.221,5.221,0,0,0,.6,2.376H0V8.008a4.382,4.382,0,0,1,2.725-1h0.1Z"/>
  ]
  getViewBox = () => '0 0 16 16'
}
